<mat-vertical-stepper [linear]="isLinear" #stepper>
  <mat-step [stepControl]="firstFormGroup">
    <form [formGroup]="firstFormGroup">
      <ng-template matStepLabel>Datos generales</ng-template>

      <mat-grid-list cols="2" rowHeight="60px" gutterSize="30px">
        <mat-grid-tile colspan="2">
          <mat-form-field>
            <mat-label>Nombre</mat-label>
            <input matInput placeholder="Nombre completo" formControlName="ctrlNombre" required>
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile colspan="1">
          <mat-form-field>
            <mat-label>Correo electrónico</mat-label>
            <input matInput placeholder='Correo electrónico a donde se enviará la cotización'
              formControlName='ctrlCorreo' type='email' required>
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile colspan="1">
          <mat-form-field>
            <mat-label>Teléfono</mat-label>
            <input matInput placeholder="Número de teléfono (Oficina, Móvil)" formControlName="ctrlTelefono" required maxlength=10>
          </mat-form-field>
        </mat-grid-tile>
      </mat-grid-list>
      <div>
        <button mat-stroked-button color="primary" matStepperNext>Siguiente</button>
      </div>
    </form>
  </mat-step>
  <mat-step [stepControl]="secondFormGroup">
    <form [formGroup]="secondFormGroup">
      <ng-template matStepLabel>Descripción de cotización</ng-template>
      <mat-grid-list cols="2" rowHeight="60px" gutterSize="30px">
        <mat-grid-tile colspan="2">
          <mat-form-field>
            <mat-label>Descripción del servicio</mat-label>
            <input matInput placeholder="Descripcion general de lo que se quiere importar o exportar" formControlName="ctrlDescripcion" required>
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="2">
          <mat-form-field>
            <mat-label>Observaciones</mat-label>
            <input matInput placeholder="Consideraciones extra del servicio solicitado" formControlName="ctrlObservaciones">
          </mat-form-field>
        </mat-grid-tile>
      </mat-grid-list>
      <div>
        <button mat-stroked-button color="primary" matStepperNext>Siguiente</button>
      </div>
    </form>
  </mat-step>
  <mat-step [stepControl]="thirdFormGroup">
    <form [formGroup]="thirdFormGroup">
      <ng-template matStepLabel>Requerimientos de la cotización</ng-template>
      <mat-grid-list cols="2" rowHeight="60px" gutterSize="30px">
        <mat-grid-tile>
          <mat-form-field>
            <mat-label>Aduanas</mat-label>
            <mat-select formControlName="ctrlAduana" (selectionChange)="onAduanasChange($event)" required>
              <mat-option *ngFor="let aduana of aduanas" [value]="aduana.payload.doc.id">
                {{aduana.payload.doc.data().Nombre}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile>
          <mat-form-field>
            <mat-label>Tipo Transporte</mat-label>
            <mat-select formControlName="ctrlTipoTransporte">
              <mat-option *ngFor="let transporte of tiposTransporte" [value]="transporte.payload.doc.id" required>
                {{transporte.payload.doc.data().Transporte}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile>
          <mat-form-field>
            <mat-label>Tipo Operación</mat-label>
            <mat-select formControlName="ctrlTipoOperacion" (selectionChange)="onTiposOperacionChange($event)" required>
              <mat-option *ngFor="let operacion of tiposOperacion" [value]="operacion.value">
                {{operacion.description}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile>
          <mat-form-field>
            <mat-label>Honorarios</mat-label>
            <mat-select formControlName="ctrlHonorarios" required>
              <mat-option *ngFor="let honorario of honorarios" [value]="honorario.payload.doc.id">
                <div *ngIf="honorario.payload.doc.data().Unidad">
                {{honorario.payload.doc.data().Descripcion + '(' + honorario.payload.doc.data().Unidad + ')' }}
              </div>
              <div *ngIf="!honorario.payload.doc.data().Unidad">
                {{honorario.payload.doc.data().Descripcion}}
              </div>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="2">
          <mat-form-field>
            <mat-label>Otras servicios</mat-label>
            <mat-select formControlName="ctrlOtrosServicios" multiple>
              <mat-option *ngFor="let otroServicio of otrosServicios" [value]="otroServicio.payload.doc.id">
                <div *ngIf="otroServicio.payload.doc.data().Unidad">
                  {{otroServicio.payload.doc.data().Descripcion + '(' + otroServicio.payload.doc.data().Unidad + ')' }}
                </div>
                <div *ngIf="!otroServicio.payload.doc.data().Unidad">
                  {{otroServicio.payload.doc.data().Descripcion}}
                </div>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </mat-grid-tile>
      </mat-grid-list>
      <div>
        <button [disabled]="firstFormGroup.invalid || secondFormGroup.invalid || thirdFormGroup.invalid" mat-stroked-button (click)="sendEmail()" color="primary">Generar cotización</button>
      </div>
    </form>
  </mat-step>
</mat-vertical-stepper>
